export default {
	sec_01: {
		title: {
			one: 'Pay at your go-To Store',
			two: 'with ',
			three: 'JP WOLRD Pay',
		},
		desc: {
			one: 'Paying directly is as easy as scanning QR codes',
			two: 'when paying and does not require touch.',
			three: "You don't have to carry cards or cash, just use the app.",
		},
		btn: {
			one: 'Sign up',
			two: 'Login',
		},
	},
	sec_04: {
		title: 'Welcome to the future currency system',
		cards: {
			one: {
				title: 'Secure payment',
				description: {
					one: 'Your information will not be remembered',
					two: 'when you make an offline payment.',
				},
			},
			two: {
				title: 'At a nearby merchants',
				description: {
					one: 'Find merchants with JP WOLRD Pay anytime,',
					two: 'anywhere and use it.',
				},
			},
			three: {
				title: 'Without cash',
				description: {
					one: 'Do you still carry cash?',
					two: 'Use JP WOLRD Pay on your phone right away.',
				},
			},
		},
	},
	sec_06: {
		title: {
			one: '3-steps payment with QR code',
			two: 'You need JP WOLRD Pay ',
			three: 'app and account.',
		},
		step: {
			one: {
				title: 'STEP 01.',
				subTitle: 'Scan or Show',
				desc: {
					one: 'Tap the QR iPhone, select Scan when the seller presents the',
					two: 'code, or tap Show to pay if you are requesting a QR code.',
				},
			},
			two: {
				title: 'STEP 02.',
				subTitle: 'Payment',
				desc: {
					one: 'Scan the code when the QR code is displayed',
					two: '',
				},
			},
			three: {
				title: 'STEP 03.',
				subTitle: 'Confirm',
				desc: {
					one: 'Once you receive the payment confirmation, all',
					two: 'payments will be completed.',
				},
			},
		},
	},
	sec_07: {
		title: {
			one: 'Prepare for sale',
			two: 'with QR code.',
		},
		desc: {
			one: 'Whether you start or run your business,',
			two: 'you can easily accept touch-free face-to-face payments',
			three: 'without hardware, software or card readers.',
		},
	},
};
